import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import startCase from 'lodash/startCase';
import { logOut } from 'core/store/modules/common/actions';
// eslint-disable-next-line no-restricted-imports
import { LOCAL_STORAGE_THEME, THEME_OPTIONS } from 'core/domains/theme/constants';
import { ThemeContext } from 'styled-components';
import { objectValues } from 'core/utils';
import { Feedback } from './items';
import type { MenuProps } from '../../ui';
import {
  BulbOutlined,
  Button,
  LogoutOutlined,
  MailOutlined,
  MenuOutlined,
  Dropdown,
} from '../../ui';

const themesMenu = objectValues(THEME_OPTIONS).map(key => ({
  key,
  label: startCase(key),
}));

const items: MenuProps['items'] = [
  {
    key: 'feedback',
    label: <Feedback />,
    icon: <MailOutlined />,
  },
  {
    key: 'theme',
    label: 'Themes',
    children: themesMenu,
    icon: <BulbOutlined />,
  },
  {
    type: 'divider',
  },
  {
    key: 'logout',
    label: 'Logout',
    icon: <LogoutOutlined data-test-id="logout" />,
  },
];

export function HeaderMenu() {
  const { setTheme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const onClickMenu: MenuProps['onClick'] = useCallback(({ keyPath }) => {
    const [rootKey, childKey] = keyPath;

    if (childKey === 'theme') {
      localStorage.setItem(LOCAL_STORAGE_THEME, rootKey);
      setTheme(rootKey);
    } else if (rootKey === 'logout') {
      dispatch(logOut());
    }

    return false;
  }, []);

  return (
    <Dropdown menu={{ items, onClick: onClickMenu }} trigger={['click']}>
      <Button icon={<MenuOutlined />} type="link" data-test-id="header-menu-outlined" />
    </Dropdown>
  );
}
